import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "c585f9fa-80fd-46a8-8517-7c823dd1fb27", content: "m = 0.37<br>L = 4.25 m<br>D = 0.48 m", options: {} },
  { id: "deae563c-d892-45a4-9d5e-19de9e69e07a", content: "m = 0.059<br>L = 4.25 m<br>D = 0.13 m", options: {} },
  { id: "9f309098-bd55-4b14-bfb2-75c3dd06d961", content: "m = 0.37<br>L = 8.5 m<br>D = 2.32 m", options: {} },
  { id: "c4eb58e7-f7f2-43c8-a637-d7dc105cb2a8", content: "m = 0.92<br>L = 8.5 m<br>D = 249 m", options: {} },
  { id: "cc8b97a1-634c-4e43-9eb0-eb319b3835f0", content: "m = 0.92<br>L = 4.25 m<br>D = 5 m", options: {} },
  { id: "6d291bbd-7b76-47d7-b689-64937a5d7725", content: "m = 0.92<br>L = 1.7 m<br>D = 0.48 m", options: {} },
];

export const task: Task = {
  id: "b644d155-8ed7-4696-83db-577174a8c7bc",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["c585f9fa-80fd-46a8-8517-7c823dd1fb27"],
};
